import React, { useState } from 'react';
import BadgeHeroSection from '../components/HeroSectionBadge';
import ProductInfo from '../components/ProductInfo';
import BottomPostcodeSection from '../components/BottomPostCodeSection';
import CustomerReview from '../components/CustomerReview';
import CampaignBenefits from '../components/CampaignBenefits';
import AnyQuestions from '../components/AnyQuestions';
import { graphql, useStaticQuery } from 'gatsby';
import LitStructuredText from '../components/generic/LitStructuredText';
import GetSEOData from '../data/SEO';
import SEO from '../components/SEO';

const campaign = ({ data }) => {
  const campaignData = data.datoCmsCampaignLandingPageModel;
  const sectionColor = campaignData.section1;
  const sectionPicture = campaignData.section2;
  const campaignMetricData = campaignData.campaignMetrics;
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedPackage, setSelectedPackage] = useState();
  const metricData = [
    {
      number: campaignMetricData.metric,

      fact: campaignMetricData.metricDescription,
    },
    {
      number: campaignMetricData.metric2,

      fact: campaignMetricData.metric2Description,
    },
    {
      number: campaignMetricData.metric3,

      fact: campaignMetricData.metric3Description,
    },
  ];
  const benefitData = [
    {
      className: `yellowMode`,
      heading: sectionColor.heading,
      image: sectionColor.featureImage,
      benefits: [
        {
          icon: sectionColor.icon1,
          content: sectionColor.body1,
        },
        {
          icon: sectionColor.icon2,
          content: sectionColor.body2,
        },
        {
          icon: sectionColor.icon3,
          content: sectionColor.body3,
        },
        {
          icon: sectionColor.icon4,
          content: sectionColor.body4,
        },
      ],
    },
    {
      className: `pictureMode`,
      heading: sectionPicture.heading,
      backgroundImageDesktop: sectionPicture.backgroundImage,
      backgroundImageMobile: sectionPicture.backgroundImageMobile,
      link: sectionPicture.buttonText,
      path: sectionPicture.buttonLink,
      benefits: [
        {
          icon: sectionPicture.icon1,
          content: sectionPicture.body1,
        },
        {
          icon: sectionPicture.icon2,
          content: sectionPicture.body2,
        },
        {
          icon: sectionPicture.icon3,
          content: sectionPicture.body3,
        },
        {
          icon: sectionPicture.icon4,
          content: sectionPicture.body4,
        },
      ],
    },
  ];
  let { title, description } = GetSEOData(`campaign`);
  return (
    <div className="bootstrap">
      <SEO
        title={campaignData.seoData.seoTitle ?? title}
        description={campaignData.seoData.seoDescription ?? description}
        metaTags={campaignData.seo}
      />
      <div className="campaign-container">
        <BadgeHeroSection
          heading={campaignData.heroBanner.heading}
          subHeading={campaignData.heroBanner.subheading}
          heroImageDesktop={campaignData.heroBanner.featureImage}
          heroImageMobile={campaignData.heroBanner.featureImage}
          secondaryHeroImage={campaignData.heroBanner.featureImage}
          mode={campaignData.heroBanner.colour}
          layout={campaignData.heroBanner.layout}
        />

        <div className="campaign-metric">
          <div className="campaign-metric-container">
            {campaignMetricData.metricHeading && (
              <h3 className="campaign-metric-header">
                <LitStructuredText
                  data={campaignMetricData.metricHeading}
                  basic
                />
              </h3>
            )}
            <div className="campaign-metric-inner">
              {metricData.map(({ number, fact }, index) => {
                return (
                  <div className="campaign-metric-content" key={index}>
                    {number && (
                      <div className="campaign-metric-number">
                        <h3>
                          <LitStructuredText data={number} basic />
                        </h3>
                      </div>
                    )}
                    {fact && (
                      <div className="campaign-metric-fact">
                        <LitStructuredText data={fact} basic />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <ProductInfo
          header={`Choose your perfect package here`}
          secondaryCaveat={
            '***Ofcom, Building a Full Fibre Future report, 2018'
          }
          setSelectedPlan={setSelectedPlan}
          selectedPlan={selectedPlan}
          setSelectedPackage={setSelectedPackage}
          selectedPackage={selectedPackage}
        />
        <CampaignBenefits benefitData={benefitData} />
        <BottomPostcodeSection
          heading="Are you ready to go Lit?"
          backgroundColor="Yellow"
        />
        <CustomerReview heading="See what others have to say" />
        <AnyQuestions />
      </div>
    </div>
  );
};

export default campaign;

export const query = graphql`
  query ($id: String!) {
    datoCmsCampaignLandingPageModel(id: { eq: $id }) {
      seo {
        description
        title
        twitterCard
        image {
          gatsbyImageData
        }
      }
      id
      pageTitleInternalOnly
      slug
      campaignMetrics {
        metric {
          value
        }
        metric2 {
          value
        }
        metric2Description {
          value
        }
        metric3 {
          value
        }
        metric3Description {
          value
        }
        metricDescription {
          value
        }
        metricHeading {
          value
        }
      }
      section1 {
        backgroundImage {
          gatsbyImageData
        }
        backgroundImageMobile {
          gatsbyImageData
        }
        body1 {
          value
        }
        body2 {
          value
        }
        body3 {
          value
        }
        body4 {
          value
        }
        buttonLink
        buttonText
        featureImage {
          gatsbyImageData
        }
        heading {
          value
        }
        icon1 {
          gatsbyImageData
        }
        icon2 {
          gatsbyImageData
        }
        icon3 {
          gatsbyImageData
        }
        icon4 {
          gatsbyImageData
        }
        sectionColour
      }
      section2 {
        backgroundImage {
          gatsbyImageData
        }
        backgroundImageMobile {
          gatsbyImageData
        }
        body1 {
          value
        }
        body2 {
          value
        }
        body3 {
          value
        }
        body4 {
          value
        }
        buttonLink
        buttonText
        featureImage {
          gatsbyImageData
        }
        heading {
          value
        }
        icon1 {
          gatsbyImageData
        }
        icon2 {
          gatsbyImageData
        }
        icon3 {
          gatsbyImageData
        }
        sectionColour
      }
      seoData {
        seoDescription
        seoTitle
      }
      heroBanner {
        colour
        layout
        featureImage {
          gatsbyImageData
        }
        heading {
          value
        }
        subheading {
          value
        }
      }
    }
  }
`;
// const query = () =>
//   useStaticQuery(graphql`
//     {
//       allDatoCmsHomepageModel {
//         nodes {
//           availabilityImage {
//             gatsbyImageData
//           }
//           heroImageMobile {
//             gatsbyImageData
//           }
//           heroImageDesktop {
//             gatsbyImageData
//           }
//         }
//       }
//       campaignTick: file(
//         relativePath: { eq: "campaign-images/campaignTick.png" }
//       ) {
//         childImageSharp {
//           gatsbyImageData(
//             quality: 75
//             placeholder: BLURRED
//             layout: CONSTRAINED
//             formats: [AUTO, WEBP, AVIF]
//           )
//         }
//         extension
//         publicURL
//       }
//       campaignArrow: file(
//         relativePath: { eq: "campaign-images/campaignArrow.png" }
//       ) {
//         childImageSharp {
//           gatsbyImageData(
//             quality: 75
//             placeholder: BLURRED
//             layout: CONSTRAINED
//             formats: [AUTO, WEBP, AVIF]
//           )
//         }
//         extension
//         publicURL
//       }
//       campaignShield: file(
//         relativePath: { eq: "campaign-images/campaignShield.png" }
//       ) {
//         childImageSharp {
//           gatsbyImageData(
//             quality: 75
//             placeholder: BLURRED
//             layout: CONSTRAINED
//             formats: [AUTO, WEBP, AVIF]
//           )
//         }
//         extension
//         publicURL
//       }
//       campaignFuture: file(
//         relativePath: { eq: "campaign-images/campaignFuture.png" }
//       ) {
//         childImageSharp {
//           gatsbyImageData(
//             quality: 75
//             placeholder: BLURRED
//             layout: CONSTRAINED
//             formats: [AUTO, WEBP, AVIF]
//           )
//         }
//         extension
//         publicURL
//       }
//       desktopHero: file(
//         relativePath: { eq: "hero-images/RevealtheDealdesktop.png" }
//       ) {
//         childImageSharp {
//           gatsbyImageData(
//             quality: 75
//             placeholder: BLURRED
//             layout: CONSTRAINED
//             formats: [AUTO, WEBP, AVIF]
//           )
//         }
//         extension
//         publicURL
//       }
//       mobileHero: file(
//         relativePath: { eq: "hero-images/RevealtheDealmobile.png" }
//       ) {
//         childImageSharp {
//           gatsbyImageData(
//             quality: 75
//             placeholder: BLURRED
//             layout: CONSTRAINED
//             formats: [AUTO, WEBP, AVIF]
//           )
//         }
//         extension
//         publicURL
//       }
//     }
//   `);
